import type { PanelDesignTokens } from '@primeuix/themes/types/panel'

export default {
  root: {
    color: '{content.color}',
    background: '{content.background}',
    borderColor: '{content.border.color}',
    borderRadius: '{content.border.radius}',
  },
  title: {
    fontWeight: '700',
  },
  footer: {
    padding: '1.125rem',
  },
  header: {
    padding: '1.125rem',
    borderColor: '{content.border.color}',
    borderWidth: '0 0 1px 0',
    borderRadius: '5px 5px 0 0',
  },
  content: {
    padding: '1.125rem',
  },
  colorScheme: {
    dark: {
      header: {
        color: '{text.color}',
        background: '{surface.800}',
      },
    },
    light: {
      header: {
        color: '{text.color}',
        background: '{surface.50}',
      },
    },
  },
  toggleableHeader: {
    padding: '0.25rem 1.125rem',
  },
} satisfies PanelDesignTokens
